import { createContext, useState } from 'react';

export const OnboardingContext = createContext();

const ClientOnboardingProvider = props => {
	const [signupToggler, setSignupToggler] = useState('SIGNIN');
	const [createObj, setCreateObj] = useState();
	const [emailStatus, setEmailStatus] = useState();
	const [resetPwdStatus, setResetPwdStatus] = useState(null);

	const reset = () => {
		setResetPwdStatus(null);
		setEmailStatus(null);
		setCreateObj(null);
		setSignupToggler('SIGNIN');
	};

	return (
		<OnboardingContext.Provider
			value={{
				createObj,
				signupToggler,
				emailStatus,
				resetPwdStatus,
				setSignupToggler,
				setCreateObj,
				setEmailStatus,
				setResetPwdStatus,
				reset
			}}
		>
			{props.children}
		</OnboardingContext.Provider>
	);
};

export default ClientOnboardingProvider;
